import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import FA from 'react-fontawesome';


/**
 * オーバーレイ
 */
const UnitLoading = () => {
  const loadingState = useSelector((state) => state.loading);
  const progressRateState = useSelector((state) => state.progressRate);

  // オーバーレイがセットされていない場合
  if (!loadingState.overlay) {
    return '';
  } else {
    // オーバーレイがセットされていれば表示する
    return (
      <Overlay className="page-overlay">
        <LoadWrap>
          <div>
            <FA name="refresh" className="loading"/>
          </div>
          <div>
            {progressRateState.progressRate >= 0 && <p>{progressRateState.num}/{progressRateState.total} Now uploading... {progressRateState.progressRate}%</p>}
          </div>
        </LoadWrap>
      </Overlay>
    );
  }
};


const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
  opacity: 0.5;
`;

const LoadWrap = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    min-height: 100vh;
    background-color: #FFF;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    .fa.fa-refresh {
      font-size: 4rem;

    }
`;
export default UnitLoading;

